import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  MenuItem,
  TextareaAutosize,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import {
  DatePicker,
  DesktopTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
import SelectMultipleShopEmployees from "./SelectMultipleShopEmployees";
import SelectEventPhases from "./SelectEventPhases";
import SelectWorkStation from "./SelectWorkStation";
import { AuthContext } from "../../../../context/AuthContext";
import SelectEventRFLTasks from "./SelectEventRFLTasks";
import { ArrowDropDown, Close } from "@mui/icons-material";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const JobEvent = ({
  calendarEvent,
  handleRemove,
  handleChange,
  errorMessage,
}) => {
  const theme = useTheme();
  const { authToken, ezorder, decoded } = useContext(AuthContext);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  if (calendarEvent)
    return (
      <Box sx={{}}>
        <Box sx={{ width: "100%" }}>
          {/* Start Date */}
          <Box sx={{ marginTop: "12px" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {calendarEvent.date && calendarEvent.date.isValid() && (
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Box sx={{ width: "150px", marginRight: "8px" }}>
                    <DesktopTimePicker
                      label="From"
                      value={calendarEvent.startDate}
                      onChange={(newValue) => {
                        // formik.setValues((prev) => ({
                        //   ...prev,
                        //   startDate: dayjs(newValue).tz(DEFAULT_TIMEZONE),
                        // }));
                        handleChange({
                          ...calendarEvent,
                          startDate: dayjs(newValue).tz(DEFAULT_TIMEZONE),
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          fullWidth
                          onFocus={(e) => {
                            e.target.select();
                          }}
                          {...params}
                        />
                      )}
                      // maxTime={calendarEvent.endDate}
                    />
                  </Box>
                  <Box sx={{ width: "150px", marginRight: "8px" }}>
                    <DesktopTimePicker
                      label="To"
                      value={calendarEvent.endDate}
                      onChange={(newValue) => {
                        // formik.setValues((prev) => ({
                        //   ...prev,
                        //   endDate: dayjs(newValue).tz(DEFAULT_TIMEZONE),
                        // }));
                        handleChange({
                          ...calendarEvent,
                          endDate: dayjs(newValue).tz(DEFAULT_TIMEZONE),
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          fullWidth
                          onFocus={(e) => {
                            e.target.select();
                          }}
                          {...params}
                        />
                      )}
                      // minTime={calendarEvent.endDate}
                    />
                  </Box>
                  {/* Work Station Select */}
                  {calendarEvent.eventEntity === "RFL" && (
                    <Box sx={{ width: "300px", marginRight: "8px" }}>
                      <SelectWorkStation
                        size="small"
                        fullWidth
                        label="Work Station"
                        value={calendarEvent.workStation}
                        onUpdate={(workStation) => {
                          // formik.setFieldValue("workStation", workStation);
                          handleChange({
                            ...calendarEvent,
                            workStation,
                          });
                        }}
                        onFocus={(e) => {
                          e.target.select();
                        }}
                      />
                    </Box>
                  )}

                  {/* Employee Select */}
                  <Box sx={{ flex: 1 }}>
                    <SelectMultipleShopEmployees
                      size="small"
                      fullWidth
                      label="Assign To"
                      value={calendarEvent.assignedTo}
                      onUpdate={(assignedTo) => {
                        // formik.setFieldValue("assignedTo", assignedTo);
                        handleChange({
                          ...calendarEvent,
                          assignedTo,
                        });
                      }}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                    />
                  </Box>
                </Box>
              )}
            </LocalizationProvider>
          </Box>
        </Box>

        {/* Jobs - select */}
        {/* {calendarEvent.eventEntity == "IND" && (
              <Box sx={{ marginTop: "12px" }}>
                {calendarEvent.order && (
                  <SelectEventPhases
                    jobId={calendarEvent.order.id}
                    scheduledSubPhases={calendarEvent.subPhases}
                    onUpdate={(subPhases) => {
                      //   formik.setFieldValue("subPhases", subPhases);
                      handleChange({
                        ...calendarEvent,
                        subPhases,
                      });
                    }}
                    onFocus={(e) => {
                      e.target.select();
                    }}
                  />
                )}
              </Box>
            )} */}
        {calendarEvent.eventEntity === "IND" && (
          <Box
            style={{
              flex: 1,
              // paddingLeft: 16, paddingRight: 16
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TextareaAutosize
                placeholder="Describe the tasks here"
                style={{
                  marginTop: "8px",
                  // color: "#fff",
                  flex: 1,
                }}
                fullWidth
                minRows={3}
                value={calendarEvent.eventNotes}
                onChange={(e) => {
                  // formik.setFieldValue("eventNotes", e.target.value);
                  handleChange({
                    ...calendarEvent,
                    eventNotes: e.target.value,
                  });
                }}
              />
            </Box>
          </Box>
        )}

        {calendarEvent.eventEntity == "RFL" && (
          <Box sx={{ marginTop: "12px" }}>
            {/* RFL Work Order Tasks */}
            {calendarEvent.manufacturingOrderId && (
              <SelectEventRFLTasks
                orderId={calendarEvent.manufacturingOrderId}
                scheduledRFLTasks={calendarEvent.rflTasks}
                onUpdate={(rflTasks) => {
                  //   formik.setFieldValue("rflTasks", rflTasks);
                  handleChange({
                    ...calendarEvent,
                    rflTasks,
                  });
                }}
                onFocus={(e) => {
                  e.target.select();
                }}
              />
            )}
          </Box>
        )}

        {errorMessage ? (
          <Typography sx={{ color: "#d32f2f", marginTop: "5px" }}>
            {errorMessage}
          </Typography>
        ) : (
          <></>
        )}
      </Box>
    );
};

export default JobEvent;
